/**
 * Contagem Service - Backward-Compatible Facade
 *
 * This file re-exports all types and composes the three sub-services
 * into a single default export so existing imports continue to work.
 *
 * Modules:
 *   contagemItemService   - item CRUD + UI helpers
 *   contagemExcelService  - Excel upload/download/import
 *   contagemPosContagemService - pós-contagem CRUD
 *
 * For new code prefer importing the sub-services directly:
 *   import contagemItemService from './contagem/contagemItemService'
 *   import contagemExcelService from './contagem/contagemExcelService'
 *   import contagemPosContagemService from './contagem/contagemPosContagemService'
 */

// Re-export all types for backward compatibility
export type {
  ItemContagemImportado,
  ContagemDadosImportados,
  ConfirmReplaceResponse,
  UploadExcelResponse,
  ItemContagemListResponse,
  ContagemResultadoInput,
  Divergencia,
  ErroProcessamento,
  ContagemResultadoResponse,
  ItemManualInput,
  AddItemResponse,
  DeleteItemResponse,
  UpdateItemResponse,
  PosContagemCliente,
  PosContagemClienteInput,
  ImportPosContagemResponse,
  ImportOrdemResponse,
  ConfirmReplaceOrdemResponse,
  ImportResultadoResponse,
} from './contagem/contagemTypes';

import contagemItemService from './contagem/contagemItemService';
import contagemExcelService from './contagem/contagemExcelService';
import contagemPosContagemService from './contagem/contagemPosContagemService';

// Compose sub-services into a single object matching the original ContagemService API
const contagemService = {
  // ----- Excel / Import -----
  uploadExcelEpic19: contagemExcelService.uploadExcelEpic19.bind(contagemExcelService),
  downloadExcelEpic19: contagemExcelService.downloadExcelEpic19.bind(contagemExcelService),
  downloadAndSaveExcel: contagemExcelService.downloadAndSaveExcel.bind(contagemExcelService),
  getExcelItemsEpic19: contagemExcelService.getExcelItemsEpic19.bind(contagemExcelService),
  enviarResultados: contagemExcelService.enviarResultados.bind(contagemExcelService),
  importarOrdemContagem: contagemExcelService.importarOrdemContagem.bind(contagemExcelService),
  importarResultadoContagem: contagemExcelService.importarResultadoContagem.bind(contagemExcelService),

  // ----- Items -----
  getItensEsperados: contagemItemService.getItensEsperados.bind(contagemItemService),
  getAllItensEsperados: contagemItemService.getAllItensEsperados.bind(contagemItemService),
  addItemManual: contagemItemService.addItemManual.bind(contagemItemService),
  deleteItem: contagemItemService.deleteItem.bind(contagemItemService),
  updateItemContagem: contagemItemService.updateItemContagem.bind(contagemItemService),
  getFaixaAgingLabel: contagemItemService.getFaixaAgingLabel.bind(contagemItemService),
  getFaixaAgingColor: contagemItemService.getFaixaAgingColor.bind(contagemItemService),
  convertToUIFormat: contagemItemService.convertToUIFormat.bind(contagemItemService),

  // ----- Pós-Contagem -----
  getPosContagemClientes: contagemPosContagemService.getPosContagemClientes.bind(contagemPosContagemService),
  createPosContagemCliente: contagemPosContagemService.createPosContagemCliente.bind(contagemPosContagemService),
  updatePosContagemCliente: contagemPosContagemService.updatePosContagemCliente.bind(contagemPosContagemService),
  deletePosContagemCliente: contagemPosContagemService.deletePosContagemCliente.bind(contagemPosContagemService),
  importPosContagemExcel: contagemPosContagemService.importPosContagemExcel.bind(contagemPosContagemService),
};

export default contagemService;
